enum SiteType {
  Production = 'Production',
  SiteLab = 'Site-Lab',
  QATest = 'QA-Test',
  Training = 'Training',
  Warehouse = 'Warehouse',
  PrimaryWarehouse = 'Primary Warehouse',
  VendingCommissary = 'Vending Commissary',
  SuitePantry = 'Suite Pantry',
}

export { SiteType };
